import React from "react";

import SystemLabel from "../../system/SystemLabel/SystemLabel";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import Slide from "@material-ui/core/Slide";
import SignalCellularConnectedNoInternet0BarIcon from "@material-ui/icons/SignalCellularConnectedNoInternet0Bar";
import SettingsEthernetIcon from "@material-ui/icons/SettingsEthernet";
import { Spinner } from "reactstrap";
import DevicesIcon from "@material-ui/icons/Devices";
import EventBusyIcon from "@material-ui/icons/EventBusy";
import "./LoaderStyle.css";

export class ClientConnectionFallback extends React.Component {
  state = {
    countdown: 0,
    timeToShow: 0,
  };
  componentDidMount() {}
  componentWillUnmount() {
    clearTimeout(this.timer);
    clearInterval(this.counter);
  }
  reconnect = () => {
    this.setState({ countdown: Date.now() + 30000 });
    this.props.tryReconnect();
  };

  renderMessage = () => {
    return <SystemLabel name="ConnectionErrorMessage"></SystemLabel>;
  };
  render() {
    if (this.props.connecting) return <Loader />;
    return <AlertDialogSlide reconnect={this.reconnect} breakoutFull={this.props.breakoutFull} connecting={this.props.connecting} lang={this.props.lang} forceDisc={this.props.forceDisconnected} />;
  }
}
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});
export function Loader() {
  return (
    <div id="loader-wrapper">
      <div id="loader"></div>
      <div className="inner-loader-wrapper">
        <img />
      </div>
    </div>
  );
}
export function SmallLoader() {
  return <div className="btn-loader"></div>;
}
export default function AlertDialogSlide({ reconnect, connecting, forceDisc, breakoutFull, lang }) {
  return (
    <div>
      <Dialog fullWidth={true} maxWidth={"sm"} open={true} TransitionComponent={Transition} keepMounted aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
        {forceDisc ? (
          <DialogTitle id="alert-dialog-slide-title">
            {" "}
            <React.Fragment>
              <DevicesIcon /> <SystemLabel name="SomeoneLoggedInFromAnotherDevice" languageCode={lang} />
            </React.Fragment>
          </DialogTitle>
        ) : null}
        {!forceDisc && !connecting && !breakoutFull ? (
          <DialogTitle id="alert-dialog-slide-title">
            {" "}
            <React.Fragment>
              <SignalCellularConnectedNoInternet0BarIcon />
              {"  "}
              <SystemLabel name="NoConnection" languageCode={lang} />
            </React.Fragment>{" "}
          </DialogTitle>
        ) : null}
        {breakoutFull && !connecting && !forceDisc ? (
          <DialogTitle id="alert-dialog-slide-title">
            {" "}
            <React.Fragment>
              <EventBusyIcon />
              {"  "}
              <SystemLabel name="BreakoutFull" languageCode={lang} />
            </React.Fragment>
          </DialogTitle>
        ) : null}

        <DialogContent>
          {!connecting && !forceDisc && !breakoutFull ? (
            <DialogContentText id="alert-dialog-slide-description">
              <SystemLabel name="NoConnectionInfo" languageCode={lang} />
            </DialogContentText>
          ) : null}
          {breakoutFull && !connecting && !forceDisc ? (
            <DialogContentText id="alert-dialog-slide-description">
              <SystemLabel name="ThisBreakoutIsCurrentlyFull" languageCode={lang} />
            </DialogContentText>
          ) : null}
          {forceDisc ? (
            <DialogContentText id="alert-dialog-slide-description">
              <SystemLabel name="SomeoneLoggedInFromAnotherDeviceInfo" languageCode={lang} />
            </DialogContentText>
          ) : null}
          {connecting && !forceDisc ? (
            <div style={{ textAlign: "center" }} id="alert-dialog-slide-description">
              <Spinner />
            </div>
          ) : null}
        </DialogContent>
        {!connecting && !breakoutFull ? (
          <DialogActions>
            <Button onClick={reconnect} color="primary">
              <SystemLabel name="ReConnect" languageCode={lang} />
            </Button>
          </DialogActions>
        ) : null}
      </Dialog>
    </div>
  );
}
